import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sb-teams",
  role: "tablist"
}
const _hoisted_2 = ["aria-selected"]
const _hoisted_3 = { class: "sb-team-name" }
const _hoisted_4 = { class: "sb-team-meta" }
const _hoisted_5 = ["aria-selected", "onClick"]
const _hoisted_6 = { class: "sb-team-name" }
const _hoisted_7 = { class: "sb-team-meta" }
const _hoisted_8 = { class: "bad" }
const _hoisted_9 = {
  key: 0,
  class: "pg-empty"
}
const _hoisted_10 = { class: "pg-sum" }
const _hoisted_11 = { class: "pg-sum-main" }
const _hoisted_12 = { class: "pg-sum-k" }
const _hoisted_13 = { class: "pg-sum-v" }
const _hoisted_14 = { class: "pg-stat ok" }
const _hoisted_15 = { class: "pg-stat bad" }
const _hoisted_16 = { class: "pg-stat" }
const _hoisted_17 = { class: "pg-sum-msg" }
const _hoisted_18 = {
  key: 0,
  class: "pg-grid"
}
const _hoisted_19 = ["role", "tabindex", "aria-label", "onClick", "onKeydown"]
const _hoisted_20 = { class: "pg-top" }
const _hoisted_21 = { class: "pg-cat" }
const _hoisted_22 = { class: "pg-t" }
const _hoisted_23 = {
  key: 0,
  class: "pg-why"
}
const _hoisted_24 = { class: "pg-prog" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = {
  key: 1,
  class: "pg-steps"
}
const _hoisted_29 = { class: "pg-meta" }
const _hoisted_30 = { title: "Who can see this" }
const _hoisted_31 = {
  key: 2,
  class: "pg-last"
}
const _hoisted_32 = {
  key: 3,
  class: "pg-acts"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 0,
  class: "pg-stale"
}
const _hoisted_36 = {
  key: 1,
  class: "pg-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_personal_goal_modal = _resolveComponent("personal-goal-modal")!
  const _component_personal_goal_check_in_modal = _resolveComponent("personal-goal-check-in-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loaded && (_ctx.myEmployeeID || _ctx.people.length))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.myEmployeeID)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                role: "tab",
                "aria-selected": _ctx.mine,
                class: _normalizeClass(["sb-team", _ctx.mine ? 'on' : '']),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectPerson(null)))
              }, [
                _createElementVNode("span", _hoisted_3, [
                  _createVNode(_component_svg_icon, {
                    icon: "user",
                    class: "sb-team-ic"
                  }),
                  _cache[6] || (_cache[6] = _createTextVNode("My goals", -1))
                ]),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.myGoals.length) + " goal" + _toDisplayString(_ctx.myGoals.length == 1 ? '' : 's'), 1)
              ], 10, _hoisted_2))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.people, (p) => {
            return (_openBlock(), _createElementBlock("button", {
              key: p.ID,
              type: "button",
              role: "tab",
              "aria-selected": !_ctx.mine && p.ID == _ctx.who,
              class: _normalizeClass(["sb-team", !_ctx.mine && p.ID == _ctx.who ? 'on' : '']),
              onClick: ($event: any) => (_ctx.selectPerson(p.ID))
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(p.Name), 1),
              _createElementVNode("span", _hoisted_7, [
                _createTextVNode(_toDisplayString(p.Goals.length) + " shared", 1),
                (p.Behind)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[7] || (_cache[7] = _createTextVNode(" · ", -1)),
                      _createElementVNode("b", _hoisted_8, _toDisplayString(p.Behind) + " behind", 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_5))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (!_ctx.who)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_svg_icon, { icon: "star" }),
                _cache[8] || (_cache[8] = _createElementVNode("div", null, "Personal goals need a Team Hub employee record. Contact your administrator to be linked to yours.", -1))
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.mine ? 'Your personal goals' : _ctx.whoName + '\'s shared goals'), 1),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.list.length) + " goal" + _toDisplayString(_ctx.list.length == 1 ? '' : 's'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.count('on')), 1),
                    _cache[9] || (_cache[9] = _createElementVNode("span", null, "on track", -1))
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.count('off')), 1),
                    _cache[10] || (_cache[10] = _createElementVNode("span", null, "behind", -1))
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.count('done')), 1),
                    _cache[11] || (_cache[11] = _createElementVNode("span", null, "done", -1))
                  ]),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.mine ? 'Goals for you, not just your seat: work, skills, family, health, money. You choose who sees each one.' : 'You only see the goals they chose to share with you.'), 1),
                  (_ctx.mine)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "btn pg-btn",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openGoal(null)))
                      }, "Add Goal"))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.list.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (g) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: g.ID,
                          class: _normalizeClass(["pg-card", [ _ctx.statusInfo(g.Status).cls, _ctx.mine ? 'pg-card-open' : '' ]]),
                          role: _ctx.mine ? 'button' : undefined,
                          tabindex: _ctx.mine ? 0 : undefined,
                          "aria-label": _ctx.mine ? g.Name : undefined,
                          onClick: ($event: any) => (_ctx.mine && _ctx.openGoal(g)),
                          onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.mine && _ctx.openGoal(g)), ["self"]), ["enter"])
                        }, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.categoryLabel(g.Category)), 1),
                            _createElementVNode("span", {
                              class: _normalizeClass(["pg-st", _ctx.statusInfo(g.Status).cls])
                            }, _toDisplayString(_ctx.statusInfo(g.Status).label), 3)
                          ]),
                          _createElementVNode("div", _hoisted_22, _toDisplayString(g.Name), 1),
                          (g.Why)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(g.Why), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["pg-bar", g.Status != 'off' ? 'ok' : ''])
                            }, [
                              _createElementVNode("span", {
                                style: _normalizeStyle('width:' + g.Percent + '%')
                              }, null, 4)
                            ], 2),
                            (g.TrackType == 'number')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                  _createElementVNode("b", null, _toDisplayString(_ctx.formatNumber(g.CurrentValue)), 1),
                                  _createTextVNode(" of " + _toDisplayString(_ctx.formatNumber(g.TargetValue)) + " " + _toDisplayString(g.Unit), 1)
                                ]))
                              : (g.TrackType == 'steps')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                    _createElementVNode("b", null, _toDisplayString(g.Steps.filter(s => s.Done).length), 1),
                                    _createTextVNode(" of " + _toDisplayString(g.Steps.length) + " steps", 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(g.Done ? 'Done' : 'Not yet'), 1))
                          ]),
                          (g.TrackType == 'steps' && g.Steps.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.Steps, (s, i) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: i,
                                    class: _normalizeClass(s.Done ? 'd' : '')
                                  }, [
                                    _cache[12] || (_cache[12] = _createElementVNode("i", null, null, -1)),
                                    _createTextVNode(_toDisplayString(s.Text), 1)
                                  ], 2))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("span", null, [
                              _createVNode(_component_svg_icon, { icon: "calendar" }),
                              _createTextVNode(_toDisplayString(_ctx.dueText(g)), 1)
                            ]),
                            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.visibilityLabel(g.Visibility)), 1)
                          ]),
                          (g.CheckIns.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createElementVNode("b", null, "Last check-in " + _toDisplayString(_ctx.dateLabel(_ctx.checkInDate(g.CheckIns[0]))) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(g.CheckIns[0].Note), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.mine)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _createElementVNode("div", {
                                  class: "btn pg-btn",
                                  onClick: _withModifiers(($event: any) => (_ctx.checkInGoal = g), ["stop"])
                                }, "Check In", 8, _hoisted_33),
                                _createElementVNode("div", {
                                  class: "btn-light pg-btn",
                                  title: "Add it to a meeting's agenda",
                                  onClick: _withModifiers(($event: any) => (_ctx.bringToMeeting(g)), ["stop"])
                                }, "Bring to Meeting", 8, _hoisted_34),
                                (_ctx.stale(g))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                                      _createVNode(_component_svg_icon, { icon: "clock" }),
                                      _createTextVNode(_toDisplayString(g.CheckIns.length ? 'No check-in in a month' : 'No check-in yet'), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ], 42, _hoisted_19))
                      }), 128)),
                      (_ctx.mine)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "pg-add",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openGoal(null)))
                          }, "+ Add a Goal"))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createVNode(_component_svg_icon, { icon: "star" }),
                      _createElementVNode("div", null, _toDisplayString(_ctx.mine ? 'No personal goals yet. Start with one that matters to you.' : 'Nothing shared yet.'), 1),
                      (_ctx.mine)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "btn pg-btn",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openGoal(null)))
                          }, "Add Your First Goal"))
                        : _createCommentVNode("", true)
                    ]))
              ], 64))
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.showGoal)
      ? (_openBlock(), _createBlock(_component_personal_goal_modal, {
          key: 2,
          goal: _ctx.goalToEdit,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showGoal = false)),
          onSaved: _ctx.onSaved
        }, null, 8, ["goal", "onSaved"]))
      : _createCommentVNode("", true),
    (_ctx.checkInGoal)
      ? (_openBlock(), _createBlock(_component_personal_goal_check_in_modal, {
          key: 3,
          goal: _ctx.checkInGoal,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.checkInGoal = null)),
          onSaved: _ctx.onSaved
        }, null, 8, ["goal", "onSaved"]))
      : _createCommentVNode("", true)
  ]))
}